import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Modal } from 'components/Modal';
import { SelectWithControl } from 'components/SelectWithControl';

import { useSelectionModal } from './SelectionModal.hooks';
import * as S from './SelectionModal.styles';

type SelectionModalProps = {
  onClose: () => void;
  productId: string;
};

export function SelectionModal(props: SelectionModalProps): React.ReactElement {
  const { onClose, productId } = props;

  const { handleSubmit, onSubmit, options, control, t } = useSelectionModal(
    productId,
    onClose
  );

  return (
    <Modal onClose={onClose}>
      <S.Title scale="xl3">{t('selection.chooseList')}</S.Title>

      <form onSubmit={handleSubmit(onSubmit)}>
        <S.Wrapper>
          <Headline fontFamily="LFT Zeno" scale="s" fontWeight="extraLight" color="grayDark">
            {t('selection.chooseListDescription')}
          </Headline>

          <SelectWithControl name="id" options={options} control={control} />
        </S.Wrapper>

        <S.Actions>
          <Button
            type="button"
            fontFamily="LFT Zeno"
            scale="xs"
            motive="cancelTertiary"
            onClick={onClose}
          >
            {t('common.close')}
          </Button>

          <Button fontFamily="LFT Zeno" scale="xs" motive="actionPrimary" type="submit">
            {t('common.add')}
          </Button>
        </S.Actions>
      </form>
    </Modal>
  );
}
